import { render, staticRenderFns } from "./Microscopia.vue?vue&type=template&id=189a254a"
import script from "./Microscopia.vue?vue&type=script&lang=js"
export * from "./Microscopia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports